// extracted by mini-css-extract-plugin
module.exports = {"deadlineCalendar":"UpdateDeadlineDialog__deadlineCalendar___alkB7"};